<!--  GestaoUsuarios.vue  -->
<template>
    <div class="gestao-usuarios-container">
      <div class="page-header">
        <h1 class="text-h4 font-weight-bold text-purple-darken-1">
          <v-icon class="mr-2">mdi-account-group</v-icon>
          Gestão de Usuários
        </h1>
        <p class="text-subtitle-1 text-grey-darken-1">
          Administre permissões e acessos dos usuários
        </p>
      </div>
  
      <v-card>
        <v-card-text class="pa-6">
          <div class="text-center py-8">
            <v-avatar size="80" color="purple-lighten-3" class="mb-4">
              <v-icon size="40" color="purple-darken-1">mdi-account-group</v-icon>
            </v-avatar>
            <h3 class="text-h6 text-grey mb-2">Gestão de Usuários</h3>
            <p class="text-grey">Esta funcionalidade será implementada em breve</p>
          </div>
        </v-card-text>
      </v-card>
    </div>
  </template>
  
  <script>
  export default {
    name: 'GestaoUsuarios'
  }
  </script>
  
  <style scoped>
  .gestao-usuarios-container {
    padding: 24px;
    background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
    min-height: 100vh;
  }
  
  .page-header {
    margin-bottom: 24px;
  }
  </style>